import api from "./api";
import config from "../config";

export default {
  fetchAll(opts) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}/item_buckets`,
          qs: {
            conditions: opts.ids
              ? JSON.stringify({ _id: { $in: opts.ids } })
              : undefined
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.item_buckets);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/ItemBucketFetcher.js